import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { Security } from "~types/types";

const initialState: Security[] = [];

const tickerBarSlice = createSlice({
    name: "tickerBar",
    initialState,
    reducers: {
        tickerBarFetched(state, action: PayloadAction<Security[]>) {
            Object.assign(state, action.payload);
        },
    },
});

export const { tickerBarFetched } = tickerBarSlice.actions;

export default tickerBarSlice.reducer;
